export default __webpack_public_path__ + "static/media/Profile.b6151e5c.svg";